(function(){
 'use strict';
 var root=document.querySelector('.la-short-root,.la-page');
 if(!root)return;
 var en=root.lang==='en'||root.dataset.language==='en';
 function addMaps(){
  root.querySelectorAll('#shops .bho-shop-addr,#la-retailer-directory .bho-shop-addr').forEach(function(address){
   if(address.querySelector('.la-map-link'))return;
   var row=address.closest('.bho-shop-row,.bho-shop-item')||address.parentElement;
   var name=row.querySelector('.bho-shop-en')||row.querySelector('.bho-shop-cn');
   var query=(name?name.textContent.trim()+' ':'')+address.textContent.trim()+' Singapore';
   var link=document.createElement('a');
   link.className='la-map-link';link.target='_blank';link.rel='noopener';
   link.href='https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(query);
   link.textContent=en?'Map ↗':'地图 ↗';
   link.setAttribute('aria-label',(en?'View map for ':'查看地图：')+(name?name.textContent.trim():address.textContent.trim()));
   address.append(document.createTextNode(' '),link);
  });
 }
 addMaps();
 // The long page mounts its existing retailer directory after initial parsing.
 var directory=root.querySelector('#la-retailer-directory');
 if(directory)new MutationObserver(addMaps).observe(directory,{childList:true,subtree:true});
})();

/* Approved immediate shimmer and 14 stars; no image transforms or media downloads. */
(function(){
  'use strict';
  var host=document.querySelector('.la-page #la-top .la-hero-visual');
  var product='la';
  var route=location.pathname.replace(/\/$/,'').split('/').pop();
  if(route==='dk-tonic'){host=document.querySelector('#MainContent .dk-hero-visual');product='dk';}
  if(route==='neurosight-brain-vision-support-formula'){host=document.querySelector('#MainContent .bho-compact__visual');product='neurosight';}
  if(route==='cordyceps-panax-ginseng-x-reishi-mushroom'){host=document.querySelector('#MainContent .bho-compact__visual');product='cordyceps';}
  if(!host||host.querySelector('.la-hero-effects'))return;
  var image=host.querySelector('img');
  if(!image)return;
  var layer=document.createElement('span');
  layer.className='la-hero-effects is-paused';
  layer.setAttribute('aria-hidden','true');
  var sheen=document.createElement('span');
  sheen.className='la-hero-sheen';layer.appendChild(sheen);
  [[20,30,-1,0],[79,40,-2.6,1],[16,63,-3.4,0],[83,74,-.3,1],
   [28,13,-2,1],[48,10,-.7,0],[69,18,-2.8,0],[87,27,-1.5,1],
   [11,44,-2.2,0],[88,57,-3.1,0],[22,77,-1.9,1],[74,65,-.5,0],
   [39,91,-2.4,0],[73,89,-1.2,0]].forEach(function(point){
    var star=document.createElement('span');
    star.className='la-hero-spark'+(point[3]?' la-hero-star':'');
    star.style.left=point[0]+'%';star.style.top=point[1]+'%';
    star.style.setProperty('--spark-delay',point[2]+'s');layer.appendChild(star);
  });
  if(product!=='la'){
    host.classList.add('bho-product-hero-effects-host');
    layer.setAttribute('data-product-effect',product);
    var positions=product==='dk'
      ? [[12,17],[35,11],[58,9],[80,14],[15,34],[91,33],[12,53],[91,48],[11,72],[93,66],[15,86],[91,82],[34,96],[75,96]]
      : [[15,18],[33,12],[54,9],[78,16],[18,36],[87,33],[13,56],[86,49],[19,73],[91,69],[22,88],[79,85],[39,95],[68,95]];
    layer.querySelectorAll('.la-hero-spark').forEach(function(star,index){star.style.left=positions[index][0]+'%';star.style.top=positions[index][1]+'%';});
  }
  host.appendChild(layer);
  var ready=false,visible=false;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  function place(){
    layer.style.left=image.offsetLeft+'px';layer.style.top=image.offsetTop+'px';
    layer.style.width=image.offsetWidth+'px';layer.style.height=image.offsetHeight+'px';
    layer.style.borderRadius=window.getComputedStyle(image).borderRadius;
  }
  function sync(){layer.classList.toggle('is-paused',!ready||!visible||document.hidden||reduced.matches);}
  function loaded(){
    if(!image.naturalWidth)return;
    place();ready=true;layer.classList.add('is-ready');sync();
  }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;sync();}).observe(image);
  }else{visible=true;}
  if('ResizeObserver' in window)new ResizeObserver(place).observe(image);
  else window.addEventListener('resize',place,{passive:true});
  image.addEventListener('load',loaded);
  if(image.complete)loaded();
  document.addEventListener('visibilitychange',sync);
  if(reduced.addEventListener)reduced.addEventListener('change',sync);
})();

/* Mobile package links begin at the approved product artwork. */
(function(){
  'use strict';
  var root=document.querySelector('.la-page');
  if(!root)return;
  var visual=root.querySelector('#la-order .la-order-visual');
  if(!visual)return;
  var links=root.querySelectorAll('a[href="#la-packages"]');
  var mobile=window.matchMedia('(max-width:760px)');
  visual.id='la-package-image';
  visual.style.scrollMarginTop='16px';
  function syncPackageLinks(){
    links.forEach(function(link){link.setAttribute('href',mobile.matches?'#la-package-image':'#la-packages');});
  }
  syncPackageLinks();
  if(mobile.addEventListener)mobile.addEventListener('change',syncPackageLinks);
  else mobile.addListener(syncPackageLinks);
})();